import Eth from 'web3-eth'
import { keccak256 } from '@ethersproject/keccak256'
import { getCreate2Address } from '@ethersproject/address'
import { ERC725YDataKeys } from '@lukso/lsp-smart-contracts'
import { stripHexPrefix } from 'web3-utils'

import { upGenerateLSP23addressRequest } from '@/shared/models/GenerateLSP23address'

export const calculateProxyUpAddress = (
  eth: Eth,
  salt: string,
  controllerAddress: string,
  upGenerateLSP23addressParams: upGenerateLSP23addressRequest
): string => {
  const {
    primaryImplementationContractAddress,
    secondaryImplementationContractAddress,
    secondaryContractInitializationCalldata,
    secondaryContractAddControlledContractAddress,
    secondaryContractExtraInitializationParams,
    upPostDeploymentModuleAddress,
    linkedContractsFactoryAddress,
    dataKeys,
    dataValues,
    dataKeysControllerIndex,
    dataValuesControllerIndex,
  } = upGenerateLSP23addressParams

  // Permissions are already set, just change the address of the controller we are setting it for in the Mapping
  // prettier-ignore
  dataKeys[dataKeysControllerIndex] =
    ERC725YDataKeys.LSP6['AddressPermissions:Permissions'] + stripHexPrefix(controllerAddress)

  // AddressPermissions[index] = change the controller address
  dataValues[dataValuesControllerIndex] = controllerAddress

  const postDeploymentCalldata = eth.abi.encodeParameters(
    ['bytes32[]', 'bytes[]'],
    [dataKeys, dataValues]
  )
  const generatedSalt = keccak256(
    eth.abi.encodeParameters(
      ['bytes32', 'address', 'bytes', 'bool', 'bytes', 'address', 'bytes'],
      [
        salt,
        secondaryImplementationContractAddress,
        secondaryContractInitializationCalldata,
        secondaryContractAddControlledContractAddress,
        secondaryContractExtraInitializationParams,
        upPostDeploymentModuleAddress,
        postDeploymentCalldata,
      ]
    )
  )

  return getCreate2Address(
    linkedContractsFactoryAddress,
    generatedSalt,
    keccak256(
      '0x3d602d80600a3d3981f3363d3d373d3d3d363d73' +
        stripHexPrefix(primaryImplementationContractAddress) +
        '5af43d82803e903d91602b57fd5bf3'
    )
  )
}
